import "./AppHeader.scss"
import React from "react"

const AppHeader = props => <header {...props} className="AppHeader" />

AppHeader.displayName = "AppHeader"

export default AppHeader



// WEBPACK FOOTER //
// ./src/lib/AppHeader.js